import Hls from 'hls.js'
import { sendErrorLog } from './datadog'
import { stripQuery } from './url'

type HlsContext = {
  player: string
  videoId?: string | number
}

export const createHls = (context: HlsContext) => {
  const hls = new Hls()

  hls.on(Hls.Events.ERROR, (_event, data) => {
    if (!data.fatal) return

    sendErrorLog(new Error(`HLS playback failed: ${data.details}`), {
      ...context,
      hlsErrorType: data.type,
      hlsErrorDetails: data.details,
      statusCode: data.response?.code,
      url: data.url ? stripQuery(data.url)?.href : undefined,
    })
  })

  return hls
}
